<template>
  <div class="product-detail">
    <!-- 返回按钮 -->
    <div class="back-btn" @click="goBack">
      ← 返回列表
    </div>

    <div class="detail-content">
      <!-- 左侧封面图 -->
      <div class="cover">
        <img :src="localProduct.coverImage" alt="封面图" />
      </div>

      <!-- 右侧信息 -->
      <div class="info">
        <h2>{{ localProduct.title }}</h2>
        <p class="price">
          ￥{{ localProduct.price }}
          <span class="original-price" v-if="localProduct.originalPrice">
            ￥{{ localProduct.originalPrice }}
          </span>
        </p>
        <p class="category" v-if="localProduct.categoryId">
          <span class="category-label">
            基于{{ getCategoryName(localProduct.categoryId) }}程序设计
          </span>
        </p>

        <!-- 服务选项区域 -->
        <div class="services-container">
          <div class="service-item" v-for="(s, index) in services" :key="index">
            <span class="check">✅</span> {{ s }}
          </div>
        </div>
      </div>

      <hr>

      <!-- 详情说明块 -->
      <div class="detail-description">
        <h3>详情说明</h3>
        <p class="description">{{ localProduct.description }}</p>
      </div>

      <hr>

      <!-- 详情信息图片 -->
      <div class="detail-images-container">
        <h3>详情图片</h3>
        <div class="detail-image" v-for="(coverImage, idx) in localProduct.detailImages" :key="idx">
          <img :src="coverImage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import { BASE_URL } from '@/config/index.js'

export default {
  components: { NavBar },
  data() {
    return {
      localProduct: {
        coverImage: '',
        title: '',
        description: '',
        price: '',
        originalPrice: '',
        categoryId: ''
      },
      services: [
        '远程部署',
        '程序定制',
        '代码讲解',
        '修改BUG'
      ],
      categories: [
        { id: 1, name: 'SpringBoot' },
        { id: 2, name: 'SSM' },
        { id: 3, name: '小程序' },
        { id: 4, name: 'Python' }
      ],
      descriptionText: '技术栈：Java，Springboot，Vue，Mysql\n' +
                       '软件：Idea，Navicat\n' +
                       '这里是产品的详细说明，可以写产品特点、功能描述、使用场景等。',
      detailImages: []
    }
  },
  computed: {
    htmlDescription() {
      return this.descriptionText.replace(/\n/g, '<br>');
    }
  },
  props: {
    product: {
      type: Object,
      default: () => ({}) // 防止未传时报错
    },
    detailToken: [Number, String],
    clickView: String
  },
  watch: {
    // 监听 token：每次 token 变都会发请求（无视 keyword 是否变化）
    detailToken: {
      immediate: true,
      handler() {
        this.getProductDetail(this.product.id)
      }
    }
  },
  methods: {
    goBack() {
      // 根据需要返回首页或分类页
      if(this.clickView === 'home'){
        this.$emit('back-home')
      }else {
        this.$emit('back-category')
      }
    },
    getCategoryName(id) {
      const category = this.categories.find(c => c.id === Number(id))
      return category ? category.name : '未知'
    },
    getProductDetail(id) {
      this.$http.get('/system/products/getProductDetail/' + id) // 调用你后端接口
        .then(res => {
          if(res.code === 200){
            this.localProduct = res.data
            this.localProduct.coverImage = BASE_URL + res.data.coverImage
            this.localProduct.detailImages = res.data.detailImages
                .split(',')                // 按逗号拆分成数组
                .map(img => BASE_URL + img.trim())  // 给每个加前缀，并去掉空格
          }else {
            console.error('加载产品状态非200', res)
            this.$message({
              message: res.msg || '加载失败',
              type: 'warning',
              duration: 3000 // 显示时长，单位毫秒
            })
          }
        })
        .catch(err => {
          console.error('加载产品失败', err)
        })
    }
  }
}
</script>

<style scoped>
.back-btn {
  cursor: pointer;
  font-size: 16px;
  color: #2575fc;
  padding: 10px 10%;
  margin-bottom: 20px;
  display: inline-block;
  transition: 0.3s;
}

.back-btn:hover {
  color: #6a11cb;
  text-decoration: underline;
}

.detail-content {
  display: flex;
  padding: 40px 5%;
  margin: 0 10%;
  gap: 40px;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.15);
}

.cover img {
  width: 100%;
  max-width: 600px;
  border-radius: 8px;
}

.description {
  white-space: pre-line; /* 保留换行符并自动换行 */
}

.info {
  flex: 1;
  min-width: 280px;
}

.info h2 {
  font-size: 32px;
  margin-bottom: 20px;
}

hr {
  border: none;           /* 去掉默认边框 */
  height: 2px;            /* 厚度 */
  background-color: #3d7bf3; /* 颜色 */
  width: 100%;            /* 宽度 100% */
}

.price {
  font-size: 24px;
  color: #e44d26;
  margin-bottom: 15px;
  font-weight: bold;
}

.original-price {
  font-size: 16px;        /* 比价格小一点 */
  color: #f8c301;         /* 黄色 */
  text-decoration: line-through; /* 划线 */
  margin-left: 10px;      /* 与现价间隔 */
}

.category {
  margin: 5px 0 0 0;
}

.category-label {
  display: inline-block;
  padding: 2px 8px;
  font-size: 18px;
  color: white;
  border-radius: 6px; /* 圆角 */
  background: linear-gradient(135deg, #6a11cb, #2575fc); /* 渐变背景 */
  font-weight: 500;
}

/* 服务选项样式 */
.services-container {
  display: grid;
  grid-template-columns: 1fr 1fr; /* 两列 */
  gap: 15px;
  padding: 20px;
  border-radius: 12px;
  background: linear-gradient(90deg, #6a11cb 0%, #2575fc 100%);
  margin-top: 10px;
}

.service-item {
  background-color: rgba(255, 255, 255, 0.2); /* 浅灰半透明 */
  border-radius: 8px;
  padding: 10px 10px;
  color: #fff;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  cursor: default;
}

/* 悬停动画 */
.service-item:hover {
  background-color: rgba(255, 255, 255, 0.35);
  transform: translateY(-3px) scale(1.03);
}

.service-item .check {
  margin-right: 8px;
  font-weight: bold;
}

/* 详情信息图片 */
.detail-images-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 40px;
}

.detail-images-container img {
  width: 100%;
  border-radius: 8px;
  object-fit: cover;
}

/* 响应式 */
@media (max-width: 768px) {
  .detail-content {
    flex-direction: column;
    padding: 20px 5%;
  }

  .cover img {
    max-width: 100%;
  }

  .info h1 {
    font-size: 24px;
  }

  .price {
    font-size: 20px;
  }

  .services-container {
    grid-template-columns: 1fr; /* 移动端一列显示 */
  }

  .detail-description,
  .detail-images-container {
    margin: 20px 5%;
    padding: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductDetail.vue